import styled, {css} from 'styled-components'

export const StyledAgendaHeaderDay = styled.p(
    ({theme: {spacing, typography}}) => css`
        ${typography.textXs};
        display: flex;
        align-items: center;
        gap: ${spacing}px;
        text-transform: capitalize;
        font-weight: 500;
    `
)

export const StyledAgendaHeaderDayNumber = styled.span(
    ({theme: {typography}}) => css`
        ${typography.textXs};
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 100%;
    `
)
